import { gql } from "@apollo/client";

export const GET_DEBIT_CARD_MERCHANT_CONTROL = gql`
  query GetDebitCardMerchantControl(
    $tokenisedDebitCardNumber: String!
    $merchantControlType: MerchantControlType!
  ) {
    debitCardControls(
      payload: { tokenisedDebitCardNumber: $tokenisedDebitCardNumber }
    ) {
      merchantControls(where: { controlType: { eq: $merchantControlType } }) {
        controlType
        declineAll
        impulseDelayRemaining
      }
    }
  }
`;

export const SET_DEBIT_CARD_MERCHANT_CONTROL = gql`
  mutation SetDebitCardMerchantControl(
    $tokenisedDebitCardNumber: String!
    $controlType: MerchantControlType!
    $declineAll: Boolean!
  ) {
    setDebitCardControls(
      payload: {
        tokenisedDebitCardNumber: $tokenisedDebitCardNumber
        debitCardControls: {
          merchantControls: {
            controlType: $controlType
            declineAll: $declineAll
          }
        }
      }
    ) {
      merchantControls(where: { controlType: { eq: $controlType } }) {
        declineAll
        impulseDelayRemaining
      }
    }
  }
`;
